<template>
  <ModalDialog
    ref="dialog"
    :title="`Glass ${glassTitle} - On Order`"
    icon="fa-dolley-flatbed"
    :showSubmit="false"
    :scrollable="true"
    @closed="onClosed">

    <Spinner v-if="loading" />
    <StaticDataTable class="static-table-list" v-if="!loading && glassSize">
      <template v-slot:header>
        <tr>
          <th>Purchase Order</th>
          <th>Supplier</th>
          <th>Advised Receiving</th>
          <th>On Order</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="purchaseOrder in glassSize.purchaseOrders" :key="purchaseOrder.id">
          <td class="font-weight-bold">
            <LinkPurchaseOrder :id="purchaseOrder.id" :name="purchaseOrder.sequenceNumber ? purchaseOrder.sequenceNumber : 'Purchase Order'" />
          </td>
          <td>
            <LinkContact :id="purchaseOrder.contact.id" :name="purchaseOrder.contact.name" />
          </td>
          <td>
            <span v-if="purchaseOrder.dateAdvised">{{purchaseOrder.dateAdvised | formatDate}}</span>
            <span v-else>Unknown</span>
          </td>
          <td>{{purchaseOrder.onOrder}}</td>
        </tr>
      </template>
      <template v-slot:empty v-if="!glassSize.purchaseOrders || glassSize.purchaseOrders.length == 0">No stock currently on order</template>
    </StaticDataTable>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import StaticDataTable from '@/components/table/staticDataTable.vue'

export default {
  name: "GlassSizePODialog",
  mixins: [
    ModalDialogMixin,
  ],
  components: {
    ModalDialog,
    StaticDataTable
  },
  props: {
    stockId: Number,
    glassSizeId: Number
  },
  data() {
    return {
      loading: false,
      glassSize: null
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    glassTitle() {
      if(this.glassSize) {
        return `${this.glassSize.height}x${this.glassSize.width}`
      }
      return ''
    }
  },
  methods: {
    show() {
      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    requestData() {
      this.loading = true
      this.$apiService.inventoryService.getGlassSize(this.stockId, this.glassSizeId)
      .then(response => {
        this.glassSize = response.data
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>